import { motion, AnimatePresence } from 'framer-motion';
import { submenu } from '../../utils/animations';
import { ChevronRight } from 'lucide-react';

const SubMenu = ({ item, isVisible, onServiceClick, onMouseEnter, onMouseLeave }) => {

  if (!item) return null;

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className="fixed top-0 left-80 h-full w-96 bg-primary-beige z-50 shadow-2xl overflow-y-auto border-l-2 border-primary-brown"
          variants={submenu}
          initial="hidden"
          animate="visible"
          exit="exit"
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          <div className="pt-20 px-8 pb-20">
            {/* Category Title */}
            <motion.h3
              className="text-3xl font-serif text-dark mb-8"
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
            >
              {item.title}
            </motion.h3>

            {/* Services List */}
            <div className="space-y-6">
              {item.services.map((service, index) => (
                <motion.button
                  key={service.id}
                  onClick={() => onServiceClick(item.path, service.sectionId)}
                  className="w-full text-left group"
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.1 * (index + 1) }}
                  whileHover={{ x: 10 }}
                >
                  <div className="border-l-2 border-primary-brown pl-4 py-3 hover:border-dark transition-colors">
                    <div className="flex items-start justify-between">
                      <div className="flex-1">
                        <h4 className="text-lg font-medium text-dark mb-2 group-hover:text-primary-brown transition-colors">
                          {service.title}
                        </h4>
                        {/* Show description only if no subcategories */}
                        {(!service.subcategories || service.subcategories.length === 0) && (
                          <p className="text-sm text-dark-light leading-relaxed">
                            {service.description}
                          </p>
                        )}
                        {/* Subcategories as bullet points */}
                        {service.subcategories && service.subcategories.length > 0 && (
                          <ul className="mt-3 space-y-3">
                            {service.subcategories.map((subcategory) => (
                              <li key={subcategory.id} className="text-sm text-dark-light block">
                                • {subcategory.name}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                      <ChevronRight
                        size={20}
                        className="text-primary-brown mt-1 ml-2 group-hover:translate-x-1 transition-transform"
                      />
                    </div>
                  </div>
                </motion.button>
              ))}
            </div>

            {/* Decorative Element */}
            <motion.div
              className="absolute bottom-8 left-8 right-8"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.4 }}
            >
              
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SubMenu;